import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {API_LOGIN, API_URL} from '../../constants';
import {Storage} from "@ionic/storage";
import {Subject} from "rxjs/Subject";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {

  private keys = ["accessToken", "user_id", "expires_at", "name", "email"];

  isLogged: boolean = false;

  getCrendentials: Subject<AuthResponse> = new BehaviorSubject({
    accessToken: '',
    user_id: '',
    expires_at: '',
    name: '',
    email: ''
  });


  constructor(public http: HttpClient, private storage: Storage) {
    console.log('Hello AuthProvider Provider');
    this.fillCredentials(this.keys);
  }

  fillCredentials(keys) {

    Promise.all(
      this.keys.map((key) => this.storage.get(`auth-${key}`))
    ).then((res) => {
      if (res && res[0]) {
        let obj: AuthResponse = res.reduce((acc, el, i) => (acc[keys[i]] = el, acc), {});
        this.isLogged = true;
        this.getCrendentials.next(obj);
      }
      return true;
    });

  }

  clearCredentials() {
    return Promise.all(this.keys.map((key) => this.storage.remove(`auth-${key}`)))
      .then(() => {
        this.isLogged = false;
        this.getCrendentials.next({accessToken: '', user_id: '', 'expires_at': '', name: '', email: ''});
        return this.storage.get('accessToken');
      });
  }

  makeLogin(data) {

    return this.http.post(`${API_URL}${API_LOGIN}`, data);

  }

  saveCredentials(data: AuthResponse) {


    return Promise.all(
      Object.keys(data)
        .map((key) => this.storage.set(`auth-${key}`, data[key]))
    ).then(() => {
      this.getCrendentials.next(data);
      return true;
    })


  }

}

export class AuthResponse {
  accessToken;
  user_id;
  expires_at;
  name;
  email;
}




// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts